import { useState } from 'react'
import useSWR from 'swr'
import { api } from '@/api'

export default function AdminBeauticians() {
  const [isEditing, setIsEditing] = useState(false)
  const [editingBeautician, setEditingBeautician] = useState<any>(null)

  const { data, mutate } = useSWR('/beauticians', () => api.beauticians.getAll())
  const beauticians = data?.data || []

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    
    const beauticianData = {
      name: formData.get('name') as string,
      specialty: formData.get('specialty') as string,
      description: formData.get('description') as string,
      phone: formData.get('phone') as string,
    }

    if (editingBeautician) {
      await api.beauticians.update(editingBeautician.id, beauticianData)
    } else {
      await api.beauticians.create(beauticianData)
    }

    setIsEditing(false)
    setEditingBeautician(null)
    mutate()
  }

  const handleDelete = async (id: number) => {
    await api.beauticians.delete(id)
    mutate()
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-900">美容师管理</h2>
        <button
          onClick={() => {
            setEditingBeautician(null)
            setIsEditing(true)
          }}
          className="btn-primary py-2 px-4 text-sm"
        >
          添加美容师
        </button>
      </div>

      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <form onSubmit={handleSubmit} className="card w-full max-w-md">
            <h3 className="font-semibold text-lg mb-4">
              {editingBeautician ? '编辑美容师' : '添加美容师'}
            </h3>

            <div className="space-y-3">
              <input
                name="name"
                defaultValue={editingBeautician?.name}
                placeholder="姓名"
                className="input"
                required
              />
              <input
                name="specialty"
                defaultValue={editingBeautician?.specialty}
                placeholder="专长"
                className="input"
              />
              <input
                name="phone"
                type="tel"
                defaultValue={editingBeautician?.phone}
                placeholder="电话"
                className="input"
              />
              <textarea
                name="description"
                defaultValue={editingBeautician?.description}
                placeholder="简介"
                className="input resize-none"
                rows={3}
              />
            </div>

            <div className="flex gap-2 mt-4">
              <button type="button" onClick={() => setIsEditing(false)} className="btn-secondary flex-1">
                取消
              </button>
              <button type="submit" className="btn-primary flex-1">
                保存
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="space-y-3">
        {beauticians.map(beautician => (
          <div key={beautician.id} className="card">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center font-medium text-primary-600">
                {beautician.name[0]}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900">{beautician.name}</h3>
                <p className="text-sm text-gray-500">{beautician.specialty}</p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setEditingBeautician(beautician)
                    setIsEditing(true)
                  }}
                  className="text-sm text-primary-600"
                >
                  编辑
                </button>
                <button
                  onClick={() => handleDelete(beautician.id)}
                  className="text-sm text-red-600"
                >
                  删除
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
